import { render } from "./CreateTaskWork.vue?vue&type=template&id=6d4aac3c"
import script from "./CreateTaskWork.vue?vue&type=script&lang=js"
export * from "./CreateTaskWork.vue?vue&type=script&lang=js"

import "./CreateTaskWork.vue?vue&type=style&index=0&id=6d4aac3c&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__